<template>
  <div>
    <div v-if="show" class="intercom">
      <div class="intercom-box">
        <div class="title">{{ title }}</div>
        <el-space>
          <el-button type="primary" size="small" :loading="answerLoading == 1"
            @click="sendAudioVideo2(1, 'go-video')">接听</el-button>
          <el-button type="danger" size="small" :loading="answerLoading == 2"
            @click="sendAudioVideo2(0), 'go-video'">挂断</el-button>
        </el-space>
      </div>
    </div>
    <div class="video-box" v-if="dialogVisible" :style="videoBoxStyle">
      <div class="center">
        <ul @mousedown="startDrag">
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div class="video" id="go-video"></div>
        <div class="title">{{ title }}</div>
        <el-button type="danger" size="small" :loading="answerLoading == 2"
          @click="sendAudioVideo2(0), 'go-video'">挂断</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global domTrtc */
export default {
  name: '',
  data() {
    return {
      show: false,
      dialogVisible: false,
      title: '',
      curData: null, //当前数据
      sn: '',
      portId: '',
      answerLoading: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      videoBoxStyle: {
        position: 'fixed',
        top: '20vh',
        left: '50%',
        zIndex: 8,
        width: '500px',
        padding: '24px',
        marginLeft: '-280px',
        backgroundColor: '#fff',
        borderRadius: '16px',
      },
    }
  },
  created() {
    this.urtcAuth()
  },
  mounted() {
  },
  methods: {
    urtcAuth() {
      let appId = process.env.VUE_APP_URTC_APPID
      let appKey = process.env.VUE_APP_URTC_APPKEY
      domTrtc.URTC.urtcAuth({
        username: appId,
        password: appKey,
      })
    },
    open(title, data, url, type) {
      this.title = title
      this.sn = data.device_no
      this.portId = data.gate_id.toString()
      this.curData = data
      if (type == 1) {
        this.sendAudioVideo2(type, 'go-video', url)
      } else {
        this.show = true
      }
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    sendAudioVideo2(openVoice, elementId, url) {
      this.show = false
      let sn = this.sn
      let portId = this.portId
      let rtspUrl = 'interCamera'
      let userId = JSON.parse(this.getStore('user')).user.id
      let expireTmSec = 5
      if (!sn || !rtspUrl || !portId || !userId) {
        alert('序号、通道ID、值守ID不能为空')
        return
      }

      if (openVoice == 1) {
        this.answerLoading = 1
        this.dialogVisible = true
        this.startAudioVideoCount();
        this.$emit('callingAccept', this.curData, 2)
      } else {
        this.dialogVisible = false
        this.answerLoading = 2
        this.$emit('callingAccept', this.curData, 3)
      }


      domTrtc.URTC.urtcVideo2(
        sn,
        rtspUrl,
        portId,
        userId,
        elementId,
        openVoice,
        expireTmSec
      )

      this.sleep(1000).then(() => {
        domTrtc.URTC.urtcVoice2(
          sn,
          portId,
          userId,
          null,
          openVoice,
          expireTmSec
        )
      });
    },
    startAudioVideoCount() {
      let time = 60 * 5
      const countdownTime = setInterval(() => {
        time--
        if (time == 0) {
          clearInterval(countdownTime)
          this.sendAudioVideo2(0, 'video' + this.portId)
        }
      }, 1000);

    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;

      const videoBox = this.$el.querySelector('.video-box');
      this.offsetX = e.clientX - videoBox.getBoundingClientRect().left;
      this.offsetY = e.clientY - videoBox.getBoundingClientRect().top;

      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDragging(e) {
      if (!this.isDragging) return;
      this.videoBoxStyle.left = `${e.clientX - this.offsetX}px`;
      this.videoBoxStyle.top = `${e.clientY - this.offsetY}px`;
      this.videoBoxStyle.marginLeft = '0px'; // Clear margin-left when dragging
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.el-dialog__header) {
  display: none;
}

.intercom-box {
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -120px;
  width: 240px;
  padding: 30px;
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  z-index: 1;

  .title {
    padding-bottom: 20px;
    font-weight: bold;
  }
}

.video-box {
  position: fixed;
  top: 20vh;
  left: 45%;
  z-index: 8;
  width: 450px;
  padding: 24px;
  margin-left: -200px;
  background-color: #fff;
  border-radius: 16px;
  box-sizing: border-box;

  ul {
    margin-bottom: 12px;
    cursor: all-scroll;
  }

  li {
    width: 40px;
    height: 4px;
    background-color: #bbb;
    margin: 0 auto 3px;
  }

  .video {
    width: 450px;
    height: 450px;
    margin: 0 auto 12px;
    border-radius: 8px;
    overflow: hidden;
  }

  .title {
    padding: 12px 0;
  }
}
</style>